((
    ($) => {
        $(document).ready(function () {
            var ringer = {
                // countdown_to: "10/31/2014",
                countdown_to: "11/04/2021",
                rings: {
                    'DAYS': {
                        s: 86400000, // mseconds in a day,
                        max: 365
                    },
                    'HOURS': {
                        s: 3600000, // mseconds per hour,
                        max: 24
                    },
                    'MINUTES': {
                        s: 60000, // mseconds per minute
                        max: 60
                    },
                    'SECONDS': {
                        s: 1000,
                        max: 60
                    }
                    // 'MICROSEC': {
                    //     s: 10,
                    //     max: 100
                    // }
                },
                r_count: 4,
                r_spacing: 10, // px
                r_size: 130, // px
                r_thickness: 4, // px
                update_interval: 11, // ms

                init: function (counter) {

                    $r = ringer;
                    $r.cvs = document.createElement('canvas');

                    $r.size = {
                        w: ($r.r_size + $r.r_thickness) * $r.r_count + ($r.r_spacing * ($r.r_count - 1)),
                        h: ($r.r_size + $r.r_thickness)
                    };


                    $r.cvs.setAttribute('width', $r.size.w);
                    $r.cvs.setAttribute('height', $r.size.h);
                    $r.ctx = $r.cvs.getContext('2d');
                    counter.append($r.cvs);
                    $r.cvs = $($r.cvs);
                    $r.ctx.textAlign = 'center';
                    $r.actual_size = $r.r_size + $r.r_thickness;
                    $r.countdown_to_time = new Date($r.countdown_to).getTime();
                    $r.cvs.css({width: $r.size.w + "px", height: $r.size.h + "px"});
                    $r.go();
                },
                ctx: null,
                go: function () {
                    var idx = 0;

                    $r.time = (new Date().getTime()) - $r.countdown_to_time;


                    for (var r_key in $r.rings) $r.unit(idx++, r_key, $r.rings[r_key]);

                    setTimeout($r.go, $r.update_interval);
                },
                unit: function (idx, label, ring) {
                    var x, y, value, ring_secs = ring.s;
                    value = parseFloat($r.time / ring_secs);
                    $r.time -= Math.round(parseInt(value)) * ring_secs;
                    value = Math.abs(value);

                    x = ($r.r_size * .5 + $r.r_thickness * .5);
                    x += +(idx * ($r.r_size + $r.r_spacing + $r.r_thickness));
                    y = $r.r_size * .5;
                    y += $r.r_thickness * .5;


                    // calculate arc end angle
                    var degrees = 360 - (value / ring.max) * 360.0;
                    var endAngle = degrees * (Math.PI / 180);

                    $r.ctx.save();

                    $r.ctx.translate(x, y);
                    $r.ctx.clearRect($r.actual_size * -0.5, $r.actual_size * -0.5, $r.actual_size, $r.actual_size);

                    // first circle
                    $r.ctx.strokeStyle = "rgba(0,0,0,0.2)";
                    $r.ctx.beginPath();
                    $r.ctx.arc(0, 0, $r.r_size / 2, 0, 2 * Math.PI, 2);
                    $r.ctx.lineWidth = $r.r_thickness;
                    $r.ctx.stroke();

                    // second circle
                    $r.ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                    $r.ctx.beginPath();
                    $r.ctx.arc(0, 0, $r.r_size / 2, 0, endAngle, 1);
                    $r.ctx.lineWidth = $r.r_thickness;
                    $r.ctx.stroke();

                    // label
                    $r.ctx.fillStyle = "#ffffff";

                    $r.ctx.font = '500 15px Raleway';
                    if ($(window).width() < 360) {
                        $r.ctx.font = '500 8px Raleway';
                        $r.ctx.fillText(label, 0, 15);
                    } else if ($(window).width() < 420) {
                        $r.ctx.font = '500 10px Raleway';
                        $r.ctx.fillText(label, 0, 15);
                    } else if ($(window).width() < 576) {
                        $r.ctx.font = '500 12px Raleway';
                        $r.ctx.fillText(label, 0, 15);
                    } else {
                        $r.ctx.fillText(label, 0, 23);
                    }


                    $r.ctx.font = 'bold 40px Raleway';
                    if ($(window).width() < 360) {
                        $r.ctx.font = 'bold 18px Raleway';
                    } else if ($(window).width() < 420) {
                        $r.ctx.font = 'bold 22px Raleway';
                    } else if ($(window).width() < 576) {
                        $r.ctx.font = 'bold 25px Raleway';
                    } else if ($(window).width() < 992) {
                        $r.ctx.font = 'bold 35px Raleway';
                    }
                    $r.ctx.fillText(Math.floor(value), 0, 0);

                    $r.ctx.restore();
                }
            }
            if ($(window).width() < 360) {
                ringer.r_size = 55;
            } else if ($(window).width() < 420) {
                ringer.r_size = 70;
            } else if ($(window).width() < 576) {
                ringer.r_size = 80;
            } else if ($(window).width() < 992) {
                ringer.r_size = 110;
            }

            const counter = $('.countdown');
            counter.each(function (index, count) {
                ringer.countdown_to = $(count).data('countdown_to');
                ringer.init($(count));
            });


        })
    }
)
(jQuery));